import { render, staticRenderFns } from "./editexam.vue?vue&type=template&id=3809d827&scoped=true"
import script from "./editexam.vue?vue&type=script&lang=js"
export * from "./editexam.vue?vue&type=script&lang=js"
import style0 from "./editexam.vue?vue&type=style&index=0&id=3809d827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809d827",
  null
  
)

export default component.exports